<template>
  <section :style="style" class="ugc-tray-wrapper-edit">
    <button
      type="button"
      class="button ugc-tray-wrapper-button ugc-tray-wrapper-edit-apply-button"
      @click="clicked"
      :disabled="disableButton"
    >
      &nbsp;
    </button>
    <div class="ugc-tray-wrapper-edit-container">
      <button
        @click="edit"
        type="button"
        class="ugc-tray-wrapper-edit-container-button"
      >
        <span class="icon icon-edit"></span>
        <span class="text">{{ translations.ugcEdit }}</span>
      </button>
    </div>
  </section>
</template>

<script>
import ugc from "@/mixins/UGC";
import undo from "@/mixins/Customizer/Undo";

export default {
  name: "CustomCheckerboardEdit",
  mixins: [ ugc, undo ],
  props: {
    disableButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    translations() {
      return this.$store.state.translations.data;
    },
    recipe_v2() {
      return this.$store.state.recipe.recipe_v2;
    },
    buttonBackgroundImageUrl() {
      const ugcTemp = this.$store.state.customCheckerboard.components[this.activeComponent] ? this.$store.state.customCheckerboard.components[this.activeComponent].ugc  : null;
      const { ugc } = this.recipe_v2.components[this.activeComponent];
      return ugcTemp && Object.keys(ugcTemp).length > 0 ? ugcTemp.placements[0].image_url : ugc.placements[0].image_url;
    },
    style() {
      return {
        "background-image": `url(${this.buttonBackgroundImageUrl})`
      };
    },
    activeComponent() {
      return this.$store.state.legacyNavigation.activeComponent;
    }
  },
  methods: {
    setDataLayer() {
      if (this.$store.getters['utils/useEcomDataLayerFormat']) {
        this.$customizerDataLayer.logAnalyticsEvent({ type: this.$customizerDataLayer.types.customizerCreateYourOwn, eventLabel: 'Custom Checkerboard' });
      }
    },

    clicked() {
      const feature = this.$recipe.getUGCFeatureType(this.activeComponent);
      this.$store.commit("ugc/tempData/SET_ACTIVE_UGC_INDEX", "ugc");

      this.setDataLayer();

      if (feature !== 'customCheckerboard') {
        this.$store.commit('swatches/SET_SWATCHES_SELECTED', {
          component: this.activeComponent,
          data: { ...this.selectedSwatches[this.activeComponent], default: false },
        });

        this.savePreviousSwatch({ feature });
      }

      if (this.$store.state.utils.configuration.enableFlyOutMenu) {
        this.updateStandardMenuForCustomCheckerboard();
      }

      this.updateCheckerboardRecipe(this.activeComponent);
      return this.applyCheckerboardTo3D(this.activeComponent);
    },

    edit() {
      // edit
      this.setDataLayer();
      const { components } = this.$store.state.customCheckerboard;
      this.$store.commit("customCheckerboard/SET_CANVAS_CONFIG",  components[this.activeComponent].canvasConfig);
      this.$store.commit("customCheckerboard/SET_TEMP_COMPONENTS");
      this.$modal.show("customCheckerboard");
    },
  },
};
</script>
